import { useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { motion } from "framer-motion";
import { ButtonSiguiente } from "@/components/ui";
import { useNavigate } from "react-router-dom";
import { safeFetch } from "@/api/safeFetch";

const Offline: React.FC = () => {
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const handleReconnect = async () => {
    setChecking(true);
    setError("");
  
    try {
      // Probamos conectividad REAL con tu propio backend
      const res = await safeFetch("/api/ping", { cache: "no-store" });
  
      if (!res.ok) throw new Error("Sin conexión real");
  
      // 🔥 SI HAY CONEXIÓN → redirige directamente
      navigate("/", { replace: true });
      return;
    } catch {
      setError("Aún no hay conexión. Inténtalo nuevamente.");
    } finally {
      setChecking(false);
    }
  };
  

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900 flex flex-col items-center justify-center text-center text-white px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-center gap-6"
      >
        <div className="bg-zinc-800/70 p-6 rounded-2xl shadow-2xl flex flex-col items-center">
          {/* 🔴 Icono con parpadeo */}
          <motion.div
            animate={{ opacity: [1, 0.4, 1] }}
            transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
          >
            <WifiOff className="w-16 h-16 text-red-500 mb-4" />
          </motion.div>

          <h1 className="text-3xl font-bold mb-2">Sin conexión a Internet</h1>
          <p className="text-zinc-400 max-w-md mb-6">
            Parece que has perdido la conexión.  
            Revisa tu red o inténtalo de nuevo en unos instantes.
          </p>

          <ButtonSiguiente
            onClick={handleReconnect}
            disabled={checking}
            className={`${
              checking ? "opacity-50 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
            } text-white px-6 py-2 rounded-xl flex items-center gap-2`}
          >
            <RefreshCw className={`w-4 h-4 ${checking ? "animate-spin" : ""}`} />
            {checking ? "Comprobando..." : "Reintentar conexión"}
          </ButtonSiguiente>

          {error && (
            <p className="text-red-400 text-sm mt-4 transition-opacity duration-300">
              {error}
            </p>
          )}
        </div>

        <p className="text-sm text-zinc-500 mt-6">
          LinkServs © {new Date().getFullYear()} — Todos los derechos reservados
        </p>
      </motion.div>
    </div>
  );
};

export default Offline;
